import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { KorisniciService } from './korisnici.service';
import * as toastr from 'toastr';
import { Korisnik } from './korisnik';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-korisnici',
  templateUrl: './korisnici.component.html',
  styleUrls: ['./korisnici.component.css'],
  providers: [KorisniciService]
})
export class KorisniciComponent implements OnInit {

  sviKorisnici: Korisnik[] = [];
  korisnikOptions: DataTables.Settings = {};
  korisnikTrigger: Subject<Korisnik> = new Subject();

  korisnikForma: FormGroup;
  korisnikEditForma: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _korisniciService: KorisniciService,
    public _router: Router
  ) { }

  ngOnInit() {
    this.dohvati();
    //Tablica početak
    this.korisnikOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
  };
  //Tablica kraj
  this.korisnikForma = this._fb.group({
    ime: [''],
    tvrtka: [''],
    telefon: [''],
    adresa: ['']
  });
  this.korisnikEditForma = this._fb.group({
    id: [''],
    ime: [''],
    tvrtka: [''],
    telefon: [''],
    adresa: ['']
  });
  }

  pripremiPodatke(korisnik){
    //  console.log(korisnik);
    this.korisnikEditForma = this._fb.group({
      id: korisnik['id'],
      ime: korisnik['ime'],
      tvrtka: korisnik['tvrtka'],
      telefon: korisnik['telefon'],
      adresa: korisnik['adresa']
    });
  }

  uredi(korisnik){
    // console.log(korisnik);
    let zaSlanje = {
      'id': korisnik['id'],
      'ime': korisnik['ime'],
      'tvrtka': korisnik['tvrtka'],
      'telefon': korisnik['telefon'],
      'adresa': korisnik['adresa'],
      'access_token': localStorage.getItem('tokenMongo')
    }
     console.log(zaSlanje);
    this._korisniciService.urediKorisnika(zaSlanje).subscribe(res => {
       console.log(res);
      if(res['createdAt']){
        toastr.success("Uspješno uređivanje!");
        this.dohvati();
      } else {
         toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  spremi(korisnikForma){
    // console.log(korisnikForma);
    const c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    const s = Array.from({length:5}, _ => c[Math.floor(Math.random()*c.length)]).join('')
    let objektZaSlanje = {
      'email': s + '@example.com',
      'password': '**********',
      'ime': korisnikForma['ime'],
      'picture': '',
      'role': '',
      'tvrtka': korisnikForma['tvrtka'],
      'adresa': korisnikForma['adresa'],
      'telefon': korisnikForma['telefon'],
      'access_token': localStorage.getItem('tokenMongo') /*'dfuV1TuPRuVFpiA1f6zbB9fB9vQqy4Kc'*/
    };
    // console.log(objektZaSlanje);
    if(korisnikForma['ime']){ /* && korisnikForma['tvrtka'] && korisnikForma['adresa'] && korisnikForma['telefon'] */
      this._korisniciService.dodajKorisnika(objektZaSlanje).subscribe(res => {
        // console.log(res);
        if(res['createdAt']){
          toastr.success("Uspješno dodan korisnik!");
          this.dohvati();
        } else {
           toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
       toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.sviKorisnici = [];
    this._korisniciService.dohvatiKorisnike().subscribe(res => {
      // console.log(res);
      if(res.length > 0){
        for(let i = 0; i < res.length; i++){
          this.sviKorisnici.push({
            'id': res[i]['id'],
            // 'email': res[i]['email'],
            // 'password': res[i]['password'],
            'ime': res[i]['ime'],
            // 'picture': res[i]['picture'],
            // 'role': res[i]['role'],
            'telefon': res[i]['telefon'],
            'tvrtka': res[i]['tvrtka'],
            'adresa': res[i]['adresa']
          });
        }
        //  console.log(this.sviKorisnici);
        this.korisnikTrigger.next();
      } else {
         toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  idiNaPravaPristupa(korisnik){
    // console.log(korisnik);
    this._router.navigate(['/pravapristupa', { idKorisnik: korisnik.id, ime: korisnik.ime }]);
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/korisnici/korisnici.component.ts